// extracted by mini-css-extract-plugin
export var infoRow = "_o2-2";
export var labelContainer = "_o2-0";
export var rightInfo = "_o2-1";